import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {PullRequestErrorState} from './components/PullRequestErrorState'
import {pullRequestsAppBuilder} from './config/app-builder'
import {pullRequestsCommitsRoute} from './routes/commits-route'
import {CommitsEntrypoint} from './routes/Commits'
import type {RouteObject} from '@github-ui/react-router'
import {pullRequestsLayoutRoute} from './routes/layout-route'
import {LayoutEntrypoint} from './routes/Layout'
import {
  pullRequestsFilesRoute,
  pullRequestsFilesWithRangeRoute,
  pullRequestsChangesRoute,
  pullRequestsChangesWithRangeRoute,
} from './routes/files-changed-routes'
import {
  ChangesEntrypoint,
  ChangesWithRangeEntrypoint,
  FilesEntrypoint,
  FilesWithRangeEntrypoint,
} from './routes/FilesChanged'
import {pullRequestsConversationsRoute} from './routes/conversations-route'
import {pullRequestsChecksRoute} from './routes/checks-route'
import {ChecksEntrypoint} from './routes/Checks'
import {ConversationsEntrypoint} from './routes/Conversations'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {pullRequestsOverviewRoute} from './routes/overview-route'
import {OverviewEntrypoint} from './routes/Overview'
import {pullRequestsFindingsRoute} from './routes/findings-route'
import {FindingsEntrypoint} from './routes/FindingsRoute'

const conversationRoute: () => RouteObject[] = () => {
  return [
    pullRequestsConversationsRoute.toRoute({
      Component: ConversationsEntrypoint,
      ErrorBoundary: PullRequestErrorState,
    }),
  ]
}

const checksRoute: () => RouteObject[] = () => {
  return [
    pullRequestsChecksRoute.toRoute({
      Component: ChecksEntrypoint,
      ErrorBoundary: PullRequestErrorState,
    }),
  ]
}

const overviewRoute: () => RouteObject[] = () => {
  // We unconditionally include the route but will manage access using the layout data's feature state
  // This differs from new files changed because use of `add_client_feature_flag` for complex / non-user FFs is deprecated
  return [
    pullRequestsOverviewRoute.toRoute({
      Component: OverviewEntrypoint,
      ErrorBoundary: PullRequestErrorState,
    }),
  ]
}

const findingsRoute: () => RouteObject[] = () => {
  if (!isFeatureEnabled('copilot_code_review_findings_ui')) return []

  return [
    pullRequestsFindingsRoute.toRoute({
      Component: FindingsEntrypoint,
      ErrorBoundary: PullRequestErrorState,
    }),
  ]
}

const commitsRouteWithLayout: () => RouteObject[] = () => [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      ...conversationRoute(),
      ...checksRoute(),
      ...overviewRoute(),
      ...findingsRoute(),
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypoint,
        ErrorBoundary: PullRequestErrorState,
      }),
    ],
  }),
]

const dataRouterRoutes: () => RouteObject[] = () => [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      ...conversationRoute(),
      ...checksRoute(),
      ...overviewRoute(),
      ...findingsRoute(),
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypoint,
        ErrorBoundary: PullRequestErrorState,
      }),
      pullRequestsFilesRoute.toRoute({
        Component: FilesEntrypoint,
        ErrorBoundary: PullRequestErrorState,
      }),
      pullRequestsFilesWithRangeRoute.toRoute({
        Component: FilesWithRangeEntrypoint,
        ErrorBoundary: PullRequestErrorState,
      }),
      pullRequestsChangesRoute.toRoute({
        Component: ChangesEntrypoint,
        ErrorBoundary: PullRequestErrorState,
      }),
      pullRequestsChangesWithRangeRoute.toRoute({
        Component: ChangesWithRangeEntrypoint,
        ErrorBoundary: PullRequestErrorState,
      }),
    ],
  }),
]

export const pullRequestsApp = pullRequestsAppBuilder.createDataRouterAppFromRoutes(params => {
  // The `react_data_router_pull_request_files` feature flag is set in the controller when the
  // user is enrolled in the New Files Changed feature preview
  if (params.isEnabled('react_data_router_pull_request_files')) {
    return dataRouterRoutes()
  }

  return commitsRouteWithLayout()
})

registerDataRouterApp(pullRequestsApp)
